export class OTA_CoveragePref {
    public coverageType: string;
}
